/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryParentConflictSubResponse
 */
export interface CategoryParentConflictSubResponse {
    /**
     * 
     * @type {number}
     * @memberof CategoryParentConflictSubResponse
     */
    categoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryParentConflictSubResponse
     */
    mongoId?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryParentConflictSubResponse
     */
    name?: string;
}

export function CategoryParentConflictSubResponseFromJSON(json: any): CategoryParentConflictSubResponse {
    return CategoryParentConflictSubResponseFromJSONTyped(json, false);
}

export function CategoryParentConflictSubResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryParentConflictSubResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'mongoId': !exists(json, 'mongoId') ? undefined : json['mongoId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CategoryParentConflictSubResponseToJSON(value?: CategoryParentConflictSubResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'mongoId': value.mongoId,
        'name': value.name,
    };
}

